import { LocationStrategy, NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { UntilDestroy } from "@ngneat/until-destroy";
import { BaseError, ComponentErrorInterface, FilledButtonComponent, NTSTranslatePipe } from '@nts/std';

@UntilDestroy()
@Component({
  selector: 'nts-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss'],
  standalone: true,
  imports: [
    FilledButtonComponent,
    SvgIconComponent,
    NTSTranslatePipe,
    NgIf
  ]
})
export class ErrorPageComponent implements ComponentErrorInterface, OnInit {

  errors: BaseError[] = [];
  errorDescription: string = 'Impossibile continuare';
  showRetry: boolean = false;
  redirectUrl: string = null;

  constructor(
    private location: LocationStrategy,
  ) {
    const state = this.location.getState();
    if (state) {

      if (state["error"] && state['error']?.length > 0) {
        this.errorDescription = state["error"].join(', ');
      }
      if (state["redirectUrl"] && state['redirectUrl']?.length > 0) {
        this.redirectUrl = state['redirectUrl'];
      }
    }
  }
  error: BaseError;

  ngOnInit(): void {
    if (this.errors?.length > 0) {
      this.errorDescription = this.errors.map((e) => e.description).join(', ');

      const error = this.errors.find(e => e.code == 'TenantInizializeInProgressError')
      if (error) {
        this.showRetry = true;
      }
    }
  }

  retry(): void {
    if (this.redirectUrl) {
      window.location.href = this.redirectUrl;
    }
    else {
      window.location.reload();
    }
  }
}
